export const alphanumeric = (str) => str.replace(/[^A-Za-z0-9]/g, '')
